module.exports = __webpack_public_path__ + "static/img/1055_small.9386974.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1055_small.png
// module id = 5NN/
// module chunks = 1